module.exports = "<button class=\"btn btn-secondary\" (click)=\"onCopyToClipboard()\">\r\n  {{ \"CopyClipboard\" | translate }}\r\n</button>"